<template>
  <div v-if="open" class="sg-overlay" @click.self="close">
    <div class="sg-modal" role="dialog" aria-modal="true" aria-labelledby="sg-title">
      <template v-if="!sent">
        <h2 id="sg-title">💡 Sugerir melhoria</h2>
        <p class="muted">Tem uma ideia, sentiu falta de algo ou viu algo confuso? Conte para nós. Lemos todas as sugestões.</p>
        <textarea v-model="body" rows="5" maxlength="3000" :placeholder="`Ex.: queria poder exportar todas as anotações de um ${$patient} em PDF`" autofocus></textarea>
        <div class="areas">
          <button v-for="a in areas" :key="a.v" type="button" :class="{ sel: area === a.v }" @click="area = area === a.v ? '' : a.v">{{ a.l }}</button>
        </div>
        <p v-if="error" class="error">{{ error }}</p>
        <div class="actions">
          <button type="button" class="btn-link" @click="close">Cancelar</button>
          <button type="button" class="btn-main" :disabled="!body.trim() || sending" @click="send">{{ sending ? "Enviando..." : "Enviar sugestão" }}</button>
        </div>
      </template>
      <div v-else class="done">
        <div class="ok">✓</div>
        <h2>Obrigado pela sugestão!</h2>
        <p class="muted">Ela já chegou para a equipe do Ordexa.</p>
        <button type="button" class="btn-main" @click="close">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { track } from "@/utils/analytics";

// Opened from anywhere with $eventbus.emit("Suggestion/open").
export default {
  name: "ComponentSuggestionModal",
  data() {
    return {
      open: false,
      body: "",
      area: "",
      sending: false,
      sent: false,
      error: null,
      areas: [
        { v: "prontuario", l: "Prontuário" },
        { v: "ia", l: "IA" },
        { v: "agenda", l: "Agenda" },
        { v: "financeiro", l: "Financeiro" },
        { v: "ferramentas", l: "Ferramentas" },
        { v: "celular", l: "Uso no celular" },
        { v: "outro", l: "Outro" },
      ],
    };
  },
  mounted() {
    this.$eventbus.on("Suggestion/open", this.show);
  },
  beforeUnmount() {
    this.$eventbus.off("Suggestion/open", this.show);
  },
  methods: {
    show() {
      this.open = true;
      this.sent = false;
      this.error = null;
      track("suggestion_open");
    },
    close() {
      this.open = false;
      if (this.sent) {
        this.body = "";
        this.area = "";
      }
    },
    async send() {
      this.sending = true;
      this.error = null;
      try {
        await this.axios.post(
          "/api/v1/suggestions",
          { body: this.body, area: this.area, page: this.$route.fullPath, meta: { contentType: "application/json" } },
          { skipGlobalErrorHandler: true },
        );
        this.sent = true;
        track("suggestion_sent", { area: this.area || "none" });
      } catch (e) {
        this.error = "Não foi possível enviar agora. Tente de novo.";
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>
.sg-overlay { position: fixed; inset: 0; background: rgba(16, 30, 36, 0.45); z-index: 4000; display: flex; align-items: center; justify-content: center; padding: 16px; }
.sg-modal { background: #fff; border-radius: 16px; padding: 22px; width: 100%; max-width: 520px; box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25); box-sizing: border-box; }
.sg-modal h2 { margin: 0 0 6px; font-size: 1.2em; }
.muted { color: #5f6f75; line-height: 1.5; margin: 0 0 12px; }
textarea { width: 100%; box-sizing: border-box; border: 1px solid #ccd8db; border-radius: 10px; padding: 0.7em; font: inherit; font-size: 16px; resize: vertical; }
.areas { display: flex; flex-wrap: wrap; gap: 6px; margin: 10px 0; }
.areas button { border: 1.5px solid #dbe6e9; background: #fff; border-radius: 999px; padding: 0.3em 0.8em; font: inherit; font-size: 0.88em; cursor: pointer; }
.areas button.sel { border-color: #1a8ea8; background: #e8f6f9; color: #0f6577; font-weight: 600; }
.actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 8px; }
.btn-main { background: #1a8ea8; color: #fff; border: none; border-radius: 10px; padding: 0.7em 1.2em; font-weight: 700; cursor: pointer; font: inherit; }
.btn-main:disabled { opacity: 0.5; }
.btn-link { background: none; border: none; color: #5f6f75; cursor: pointer; font: inherit; }
.error { color: #c0392b; margin: 0; }
.done { text-align: center; }
.ok { width: 52px; height: 52px; border-radius: 50%; background: #e6f6ea; color: #2c8a40; font-size: 1.6em; display: flex; align-items: center; justify-content: center; margin: 0 auto 8px; }
</style>
